import Image from "@/shared/components/Image/new";
import styles from "./styles.module.css";
import { formatAuthorNames } from '@/shared/functions/formatAthorNames'

const DestacadaXL = (props) => {
	const SECONDARY_CROP = '3_2_300x200';
	
	const { title, summary, url, image, author, hasBackground, customClippings = null, selectedImageId = null} = props;
	let authorsList = []
	if (author != undefined && author?.length) {
		const authorName = formatAuthorNames(author[0].name);
		author.length > 1 ? author.slice(0, 2).map(element => {

			const elementName = formatAuthorNames(element.name);
			return authorsList.push(element.slug ? `<a href=/autor/${element.slug}>${elementName}</a>` : elementName)

		}) 
		
		: authorsList.push(author[0].slug ? `<a href=/autor/${author[0].slug}>${authorName}</a>` : authorName)
	}
	const parsedAuthors = authorsList.join(' - ');
		
	const manualCrops = (selectedImageId && selectedImageId != null) ? customClippings[selectedImageId] : [];
        console.log( 'ManualCrops' , manualCrops);
	return (
		<div className={`${styles["destacadaXL-parent"]}`}>
			{authorsList &&
				<a href={url} className={`${styles["destacadaXL-container"]}`}>
					<Image
						src={image}
						alt={title}
						width={1300}
						height={655}
						srcSet={{
							mobile: SECONDARY_CROP
						}}
						className={styles["img"]}
						priority
					/>
					
					<div className={ !hasBackground ? `${styles["destacadaXL-container-text-mobile"]}` : `${styles["destacadaXL-container-text-mobile"]} ${styles["container-text-mobile-background"]}`}>
						{title != "" && <div className={`${styles["destacadaXL-mobile-title"]}`} dangerouslySetInnerHTML={{ __html: title }} />}
						{summary != "" && <div className={`${styles["destacadaXL-mobile-summary"]}`} dangerouslySetInnerHTML={{ __html: summary }} />}
					</div>
					
					<div className={ !hasBackground ? `${styles["destacadaXL-container-text"]}` : `${styles["destacadaXL-container-text"]} ${styles["container-text-background"]}`}>
						{title != "" && <div className={!hasBackground ? `${styles["destacadaXL-title"]}` : `${styles["destacadaXL-title"]} ${styles["title-background"]}`  } dangerouslySetInnerHTML={{ __html: title }} />}
						{summary != "" && <div className={!hasBackground ? `${styles["destacadaXL-summary"]}` : `${styles["destacadaXL-summary"]} ${styles["summary-background"]}`} dangerouslySetInnerHTML={{ __html: summary }} />}
					</div>
				</a>
			}
			{parsedAuthors && <div className={!hasBackground ? `${styles["destacadaXL-author"]}` : `${styles["destacadaXL-author"]} ${styles["author-background"]}`} dangerouslySetInnerHTML={{ __html: 'Por ' + parsedAuthors }} />}
		</div>
	);
};
export default DestacadaXL;
